/* eslint-disable react/jsx-props-no-spreading */
import { Link } from "@inertiajs/react";
import { AnchorHTMLAttributes, PropsWithChildren, forwardRef } from "react";

import {
  TextLinkThemeProps,
  textLinkTheme,
} from "hardcover-ui/theme/components/text";
import classNames from "lib/classNames";

type Props = {
  size?: TextLinkThemeProps["size"];
  external?: boolean;
  variant?: TextLinkThemeProps["variant"];
  underline?: boolean;
  prefetch?: boolean;
} & Partial<AnchorHTMLAttributes<HTMLAnchorElement>>;

const TextLink = forwardRef<HTMLAnchorElement, PropsWithChildren<Props>>(
  (
    {
      size = "md",
      external = false,
      variant = "normal",
      children,
      underline = true,
      className,
      ...rest
    },
    ref,
  ) => {
    const finalClassName = classNames(
      textLinkTheme.variant[variant],
      textLinkTheme.size[size],
      underline
        ? "underline hover:no-underline"
        : "no-underline hover:underline",
      className,
    );

    const props = {
      ref,
      className: finalClassName,
      ...rest,
    };

    if (external) {
      return <a {...props}>{children}</a>;
    }

    return (
      <Link ref={ref} href={props.href} className={finalClassName}>
        {children}
      </Link>
    );
  },
);

export default TextLink;
